"use strict";

var _preact = require("preact");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const RecordButton = require("./RecordButton.js");

const SubmitButton = require("./SubmitButton.js");

const StopWatch = require("./StopWatch.js");

const StreamStatus = require("./StreamStatus.js");

class RecorderScreen extends _preact.Component {
  componentWillUnmount() {
    const {
      onStop
    } = this.props;
    onStop();
  }

  render() {
    const {
      recording,
      stream: videoStream,
      recordedVideo
    } = this.props;
    const videoProps = {
      playsinline: true
    }; // show stream

    if (recording || !recordedVideo && !recording) {
      videoProps.muted = true;
      videoProps.autoplay = true;
      videoProps.srcObject = videoStream;
    } // show preview


    if (recordedVideo && !recording) {
      videoProps.muted = false;
      videoProps.controls = true;
      videoProps.src = recordedVideo; // reset srcObject in dom. If not resetted, stream sticks in element

      if (this.videoElement) {
        this.videoElement.srcObject = undefined;
      }
    }

    return (0, _preact.h)("div", {
      className: "uppy uppy-ScreenCapture-container"
    }, (0, _preact.h)("div", {
      className: "uppy-ScreenCapture-videoContainer"
    }, (0, _preact.h)(StreamStatus, this.props), (0, _preact.h)("video", _extends({
      ref: videoElement => {
        this.videoElement = videoElement;
      },
      className: "uppy-ScreenCapture-video"
    }, videoProps)), (0, _preact.h)(StopWatch, this.props)), (0, _preact.h)("div", {
      className: "uppy-ScreenCapture-buttonContainer"
    }, (0, _preact.h)(RecordButton, this.props), (0, _preact.h)(SubmitButton, this.props)));
  }

}

module.exports = RecorderScreen;